import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Currency, QuotationRevision } from '@freelancer/datastore/collections';
import { Margin } from '@freelancer/ui/margin';
import { FontWeight, TextSize } from '@freelancer/ui/text';
import { UserPerspective } from 'app/quotations/quotations.types';
import { FundType } from './quotation-payment-status-progress/quotation-payment-status-progress.component';

@Component({
  selector: 'app-quotation-payment-status',
  template: `
    <fl-text
      i18n="Quotation Add Funds Modal Payment Status Title"
      [size]="labelSize"
      [weight]="FontWeight.BOLD"
      [flMarginBottom]="Margin.XSMALL"
    >
      Payment Summary
    </fl-text>
    <fl-grid>
      <fl-col class="QuoteTotal-container" [col]="4">
        <fl-bit>
          <fl-bit class="QuoteTotal">
            <fl-text
              i18n="Quotation Add Funds Modal Payment Status Title"
              [size]="TextSize.SMALL"
              [weight]="FontWeight.BOLD"
              [flMarginBottom]="Margin.XXXSMALL"
            >
              {{ quotePrice | flCurrency: currency.code }}
            </fl-text>
            <fl-text
              i18n="Quotation Add Funds Modal Quote Total Label"
              [size]="TextSize.XSMALL"
            >
              Quote Total
            </fl-text>
          </fl-bit>
        </fl-bit>
      </fl-col>
      <fl-col [col]="8">
        <fl-bit class="FundProgress">
          <app-quotation-payment-status-progress
            [currency]="currency"
            [fundAmount]="availableFunds"
            [fundType]="FundType.AVAILABLE"
            [quotePrice]="quotePrice"
            [userPerspective]="userPerspective"
          >
          </app-quotation-payment-status-progress>
          <app-quotation-payment-status-progress
            [currency]="currency"
            [fundAmount]="releasedFunds"
            [fundType]="FundType.RELEASED"
            [quotePrice]="quotePrice"
            [userPerspective]="userPerspective"
          >
          </app-quotation-payment-status-progress>
        </fl-bit>
      </fl-col>
    </fl-grid>
  `,
  styleUrls: ['./quotation-payment-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuotationPaymentStatusComponent implements OnChanges {
  FontWeight = FontWeight;
  FundType = FundType;
  Margin = Margin;
  TextSize = TextSize;
  UserPerspective = UserPerspective;

  @Input() quotation: QuotationRevision;
  @Input() currency: Currency;
  @Input() userPerspective: UserPerspective;
  @Input() labelSize = TextSize.SMALL;

  quotePrice: number;
  availableFunds: number;
  releasedFunds: number;

  ngOnChanges(changes: SimpleChanges) {
    if (this.quotation && 'quotation' in changes) {
      const currencyId = this.quotation.defaultCurrencyId;
      this.quotePrice = this.quotation.quotePrice[currencyId];
      this.releasedFunds = this.quotation.paidAmount[currencyId] ?? 0;
      this.availableFunds = this.quotation.fundedAmount[currencyId] ?? 0;
    }
  }
}
